import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQueryEtmf } from './baseQueryEtmf';

export const etmfDocLevelApi = createApi({
  baseQuery: baseQueryEtmf,
  reducerPath: 'etmfDocLevelApi',
  endpoints: builder => ({
    getAllDocumentsByMilestonenameSiteLevel: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        milestone,
        module_section_related,
        parent_entity_related,
        user_based_details,
        originally_uploaded
      }) => ({
        url: `${endPoints.etmfApis.getAll}?country_id=${country}&site_id=${site_id}&study_id=${study_id}&is_binder_view=false&tmf_doc_milestone=${milestone}&tmf_doc_level=Site&user_based_details=${user_based_details}&limit=200&application=${application}&originally_uploaded=${originally_uploaded}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getAllDocumentsByArtifactnameStudylevel: builder.mutation<any, any>({
      query: ({ study_id, application, artifactName, module_section_related, parent_entity_related, docLevel, data = {} }) => ({
        url: `${endPoints.etmfApis.getAll}?study_id=${study_id}&tmf_doc_level=${docLevel}&is_binder_view=false${artifactName ? `&tmf_artifact_name=${artifactName}`:''}&limit=200&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        body: data, 
        method: 'POST'
      })
    }),
    getDcocListByStudyidArtifactname: builder.query<any, any>({
      query: ({
        study_id,
        site_id,
        country,
        application,
        artifactName,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.getDcocListByStudyidArtifactname, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&country=${country}&tmf_artifact_name=${artifactName}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getAllDocumentsByArtifactnameSitelevel: builder.query<any, any>({
      query: ({ country, site_id, study_id, application, artifactName, module_section_related, parent_entity_related }) => ({
        url: `${endPoints.etmfApis.getAll}?country_id=${country}&site_id=${site_id}&study_id=${study_id}&tmf_doc_level=Site&is_binder_view=false&tmf_artifact_name=${artifactName}&limit=100&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    createMasterDocEtmf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.etmfApis.createMasterDoc
        )}?study_id=${study_id}${site_id ? `&tmf_doc_site=${site_id}` : ''}${country ? `&tmf_doc_country=${country}` : ''}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'POST',
        body: data
      })
    }),
    getAllDocumentsByArtifactname: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        docLevel,
        application,
        artifactName,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${endPoints.etmfApis.getAll}?study_id=${study_id}${site_id ? `&tmf_doc_site=${site_id}` : ''}${country ? `&tmf_doc_country=${country}` : ''}${docLevel ? `&tmf_doc_level=${docLevel}` : ''}&is_binder_view=false&tmf_artifact_name=${artifactName}&limit=200&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getDocLevelBYArtifactName: builder.query<any, any>({
      query: ({ tmf_artifact_name, application, tmf_doc_level, module_section_related, parent_entity_related }) => ({
        url: `${formatString(endPoints.etmfApis.getDocLevelByArtifactName, {
          key: urlKeys.tmf_doc_level,
          value: tmf_doc_level
        })}?tmf_artifact_name=${tmf_artifact_name}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    getTmfLevel: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        tmf_level,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.getTmfLevel, {
          key: urlKeys.tmf_level,
          value: tmf_level
        })}?tmf_doc_study=${study_id}${country ? `&tmf_doc_country=${country}` : ''}${site_id ? `&tmf_doc_site=${site_id}` : ''}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    updateInlineMaterDocEtmf: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.etmfApis.updateInlineMasterDoc
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PUT',
        body: data
      })
    }),
    getEtmfDocDetailsByTmfDocumentId: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        tmfDocumentId,
        application,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.getTmfDocDetailsByStudyDocId, {
          key: urlKeys.study_id,
          value: study_id
        })}?site_id=${site_id}&country_id=${country}&tmf_document_id=${tmfDocumentId}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }), 
    getDrugSupplyArtifacts: builder.query<any, any>({
      query: ({
        study_id,
        application,
        tmf_level,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.getDrugSupplyArtifacts, {
          key: 'tmf_level',
          value: tmf_level
        })}?tmf_doc_study=${study_id}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'GET'
      })
    }),
    deleteETMFDocByFileId: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        file_master_id,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.deleteMasterDoc, {
          key: urlKeys.file_master_id,
          value: file_master_id
        })}?study_id=${study_id}${country ? `&country_id=${country}` : ''}${site_id ? `&site_id=${site_id}` : ''}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PATCH'
      })
    }),
    deleteAllETMFDocsByFileId: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        docLevel,
        application,
        file_master_id,
        module_section_related,
        parent_entity_related
      }) => ({
        url: `${formatString(endPoints.etmfApis.deleteAllDocuments, {
          key: urlKeys.file_master_id,
          value: file_master_id
        })}?study_id=${study_id}${country ? `&country_id=${country}` : ''}${site_id ? `&site_id=${site_id}` : ''}${docLevel ? `&tmf_doc_level=${docLevel}` : ''}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'PATCH'
      })
    })
  })
});

export const {
  useLazyGetAllDocumentsByMilestonenameSiteLevelQuery,
  useGetAllDocumentsByArtifactnameStudylevelMutation,
  useLazyGetDcocListByStudyidArtifactnameQuery,
  useLazyGetAllDocumentsByArtifactnameSitelevelQuery,
  useCreateMasterDocEtmfMutation,
  useLazyGetAllDocumentsByArtifactnameQuery,
  useLazyGetDocLevelBYArtifactNameQuery,
  useLazyGetTmfLevelQuery,
  useUpdateInlineMaterDocEtmfMutation,
  useLazyGetEtmfDocDetailsByTmfDocumentIdQuery,
  useLazyGetDrugSupplyArtifactsQuery,
  useDeleteETMFDocByFileIdMutation,
  useDeleteAllETMFDocsByFileIdMutation
} = etmfDocLevelApi;
